<template>
  <success-page-layout
    store-badges-button-code="body-20210304-success-page-purchase"
    web-to-mobile-flag="webPremiumPurchased"
    :promote-app-download="true"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4 m:mb-6" v-html="$t('pages.upgrade.headline')" />
      <p v-html="copy" />
    </template>

    <template v-slot:image>
      <purchase-image />
    </template>
  </success-page-layout>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import PurchaseImage from "@/pages/success-page/components/upgrade/image"
import { mapGetters } from "vuex"

export default {
  name: "PurchaseSuccess",
  components: {
    PurchaseImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    ...mapGetters(["usersEmail"]),
    copy() {
      return this.$t(`pages.upgrade.body`, { usersEmail: this.usersEmail })
    }
  },
  mounted() {
    this.$store.dispatch("loadUsersAccounts")
  }
}
</script>
